import type { DisplayUnit } from '@core';

import { formatCorridorLabel } from '../../../../utils/corridors';

import type { RangeLabelVariants } from './RangeLabel.css';
import * as css from './RangeLabel.css';

export type RangeLabelProps = {
    value: number;
    tone: RangeLabelVariants['tone'];
    placement: RangeLabelVariants['placement'];
    unit: DisplayUnit;
    position: number;
};

export const RangeLabel = ({ value, tone, placement, unit, position }: RangeLabelProps) => {
    const { integer, fraction, isNegative } = formatCorridorLabel(value, unit);

    return (
        <div className={css.rangeLabel({ tone, placement })} style={{ left: `${position}%` }}>
            {isNegative ? '-' : null}
            {integer}
            {fraction ? <span className={css.fraction}>{fraction}</span> : null}
        </div>
    );
};
